// Shared date-filter helpers for the health-events surfaces (per-site
// /site/<id>/health/status and the cross-site /operational/health table).
// Kept out of the component file so it can be imported by both without
// tripping react-refresh's "only export components" rule.

const MONTH_FILTER_COUNT = 12;

export const formatSiteDateTime = (
  isoString: string,
  timeZone: string
): string =>
  new Date(isoString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  });

export const buildMonthFilterOptions = (
  now: Date,
  timeZone: string,
  earliestMonthInclusive?: string | null
): { key: string; label: string }[] => {
  // Walk back from the start of the current month in site timezone so the
  // dropdown labels match the site's calendar. Stops at MONTH_FILTER_COUNT
  // months OR `earliestMonthInclusive` (YYYY-MM, e.g. the site's COD month),
  // whichever comes first — this prevents showing months from before the
  // site went operational.
  const fmtYearMonth = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
  });
  const fmtLabel = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    month: "long",
    year: "numeric",
  });
  const parts = fmtYearMonth.formatToParts(now);
  const yyyy = Number(parts.find((p) => p.type === "year")?.value);
  const mm = Number(parts.find((p) => p.type === "month")?.value);
  const out: { key: string; label: string }[] = [];
  for (let i = 1; i <= MONTH_FILTER_COUNT; i++) {
    const monthIdx = mm - 1 - i; // 0-based; previous complete month is i=1
    const year = yyyy + Math.floor(monthIdx / 12);
    const month = ((monthIdx % 12) + 12) % 12;
    const ref = new Date(Date.UTC(year, month, 15));
    const key = `${year}-${String(month + 1).padStart(2, "0")}`;
    if (earliestMonthInclusive && key < earliestMonthInclusive) break;
    out.push({ key, label: fmtLabel.format(ref) });
  }
  return out;
};
